// Featured Trivia Item Component
// Displays trivia items in the featured section, identical to regular trivia items
// Shows question, difficulty, stats, and tags - focused on reporting rather than interaction

import React from 'react';
import './FeaturedTriviaItem.css';

export function FeaturedTriviaItem({
  trivia,
  onTriviaClick,
  isAdmin = false,
  onDelete
}) {
  // Get question type display name
  const getQuestionTypeDisplay = (type) => {
    switch (type) {
      case 'multiple-choice': return 'Multiple Choice';
      case 'true-false': return 'True/False';
      case 'multi-select': return 'Multi-Select';
      case 'image-choice': return 'Image Choice';
      case 'ordered-list': return 'Ordered List';
      default: return type || 'Unknown';
    }
  };

  return (
    <div className="featured-trivia-item">
      {/* Row 1: Question */}
      <div className="featured-trivia-row featured-trivia-header-row">
        <h3 className="featured-trivia-question">
          {trivia.question}
        </h3>
      </div>

      {/* Row 2: Question Type + Difficulty + Likes */}
      <div className="featured-trivia-row featured-trivia-type-row">
        <div className="featured-trivia-type-info">
          <div className="featured-trivia-type-display">
            <i className="fa-solid fa-question-circle"></i>
            <span>{getQuestionTypeDisplay(trivia.questionType)}</span>
          </div>
          <span className={`featured-trivia-difficulty featured-trivia-difficulty-${trivia.difficulty}`}>
            {trivia.difficulty}
          </span>
        </div>
        <div className="featured-trivia-likes">
          <i className="fa-solid fa-thumbs-up"></i>
          <span>{trivia.likes || 0}</span>
        </div>
      </div>

      {/* Row 3: Tags */}
      <div className="featured-trivia-row featured-trivia-tags-row">
        {trivia.tags && trivia.tags.length > 0 ? (
          trivia.tags.map((tag, index) => (
            <span key={index} className="featured-trivia-tag">{tag}</span>
          ))
        ) : (
          <span className="featured-trivia-no-tags">No tags</span>
        )}
      </div>

      {/* Row 4: Success Rate Progress Bar */}
      <div className="featured-trivia-row featured-trivia-progress-row">
        <div className="featured-trivia-progress-container">
          <div className="featured-trivia-progress-header">
            <span className="progress-title">Success Rate</span>
            <span className="progress-stats">
              {trivia.attempts > 0
                ? `${Math.round((trivia.correctAttempts / trivia.attempts) * 100)}%`
                : '0%'
              } • {trivia.attempts || 0} attempts
            </span>
          </div>
          <div className="featured-trivia-progress-bar">
            <div
              className="featured-trivia-progress-fill"
              style={{
                width: trivia.attempts > 0
                  ? `${(trivia.correctAttempts / trivia.attempts) * 100}%`
                  : '0%'
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}